import { TimeOffReviewDecisionDTO } from '../types/dto/time-off-review.dto';
import { TimeOffReviewDecision } from '../types/time-off-review';

export const mapReviewDecisionToDTO = (
  decision: TimeOffReviewDecision
): TimeOffReviewDecisionDTO =>
  decision === TimeOffReviewDecision.Approve
    ? TimeOffReviewDecisionDTO.Approved
    : TimeOffReviewDecisionDTO.Declined;
